import { FC } from "react";
import { HStack, Icon, Stack, Text } from "@chakra-ui/react";

import { BagIcon, RubleIcon } from "../../../../icons";
import { IOperation } from "../../../../../api/operations/types.ts";
import { formatDate, formatPriceWithoutZeros, isStringWithNumber, isValidDate } from "../../../../../utils";

interface Props {
  operation: IOperation;
}

export const OperationItemContent: FC<Props> = ({ operation }) => {
  const isInflows = operation.type === "RETURN" || operation.type === "REPAYMENT";
  const isOutflows = operation.type === "TRANCHE";

  const icon = isOutflows ? BagIcon : RubleIcon;
  const term = isOutflows && operation.term ? `на ${operation.term} мес` : "";

  const dateFormat = {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  } as Intl.DateTimeFormatOptions;
  const formattedDate = isValidDate(operation.date) ? formatDate(new Date(operation.date!), dateFormat) : "";
  const date = formattedDate.replace(/\./, "");

  const rawAmount = operation.amount;
  const formatedAmount = isStringWithNumber(rawAmount) ? formatPriceWithoutZeros(Number(rawAmount)) : "";
  const amount = isInflows ? `+${formatedAmount}` : formatedAmount;
  const amountVariant = isInflows ? "green" : "brand";

  const getName = () => {
    switch (operation.type) {
      case "TRANCHE": return "Расход";
      case "RETURN": return "Возврат";
      case "REPAYMENT": return "Платеж";
    }
  };

  return (
    <>
      <HStack>
        <Icon as={icon} boxSize="48px" />

        <Stack spacing="3px" pl="4px" alignItems="flex-start">
          <Text variant="brand">{getName()}</Text>
          <Text fontSize="14px">{date}</Text>
        </Stack>
      </HStack>

      <Stack spacing="3px" alignItems="flex-end">
        <Text variant={amountVariant}>{amount}</Text>
        {term && <Text fontSize="14px">{term}</Text>}
      </Stack>
    </>
  );
};
